import { FC } from 'react';
// Types
import QuizTypes from 'types/QuizTypes';
// Models
import IQuiz from 'models/Quiz';
// Redux
import { useAppSelector } from 'hooks/useStore';
// Selectors
import { selectQuiz } from 'store/quiz/quizSelectors';
import { selectResult } from 'store/player/playerSelectors';
// Utilities
import { buildUserName } from 'utilities/Utilities';

const PlayerResult:FC = () => {
  // State
  const quiz:IQuiz = useAppSelector(selectQuiz);
  const result:any = useAppSelector(selectResult);

  if ( !result ) return null;
  if ( quiz.type === QuizTypes.Personality || !result.currentUserResult ) return null;
  return (
    <div
      className="
        flex items-center flex-shrink-0
        bg-primary shadow
        rounded-tr-lg rounded-tl-lg
        text-white font-bold
        p-2.5
        z-40
        overflow-hidden
      "
    >
      <div className="flex-1 flex items-center">
        <span className="mr-2">{result.currentUserResult.position}.</span>
        {buildUserName(result.currentUserResult)}
      </div>
      <span>
        {result.currentUserResult.score}
      </span>
    </div>
  )
}

export default PlayerResult;
